import {Translate} from "../Translate";

const routesConfig = [
    {
        id: 'admin_dashboard',
        title: Translate.dashboard,
        type: 'item',
        for:['admin'],
        icon:'dashboard',
        url: '/dashboard',
    },

    {
        id: 'usersManagement',
        title: Translate.usersManagement,
        type: 'collapse',
        icon: "people",
        roles: ['admin','support'],
        for: ['admin'],
        permission: 'manageSettings',
        children: [
            {
                id: 'allUsers',
                title: Translate.allUsers,
                type: 'item',
                icon: 'group',
                url: '/manage/users/view/all',
                exact:true
            },
            {
                id: 'usersActivity',
                title: Translate.usersActivity,
                type: 'item',
                icon: 'post_add',
                url: '/manage/activities',
                exact:true
            },
        ],
    },
    {
        id: 'paymentManagement',
        title: Translate.paymentManagement,
        type: 'collapse',
        icon: 'account_balance_wallet',
        roles: ['admin','support'],
        for: ['admin'],
        permission: 'managePayments',
        children: [
            {
                id: 'manageOrders',
                title: Translate.manageOrders,
                type: 'item',
                icon: 'shopping_basket',
                url: '/manage/orders',
                exact:true
            },

        ],
    },
    {
        id: 'productsList',
        title: Translate.manageProducts,
        type: 'collapse',
        roles: ['admin','support'],
        for: ['admin'],
        permission: 'manageSettings',
        icon: 'shopping_cart',
        children: [
            {
                id: 'manageSafeCoins',
                title: Translate.manageSafeCoins,
                type: 'item',
                icon: 'sports_soccer',
                url: '/manage/safe-coins',
                exact:true
            },
            {
                id: 'managePlatforms',
                title: Translate.managePlatforms,
                type: 'item',
                icon: 'sports_esports',
                url: '/manage/manage-platforms',
                exact:true
            },

        ],
    },
    {
        id: 'contents',
        title: Translate.contents,
        type: 'collapse',
        roles: ['admin','support'],
        for: ['admin'],
        icon: 'article',
        children: [
            {
                id: 'addContent',
                title: Translate.addContent,
                type: 'item',
                icon: 'create',
                url: '/news/make',
                exact:true
            },
            {
                id: 'viewContent',
                title: Translate.viewContent,
                type: 'item',
                icon: 'view_list',
                url: '/news',
                exact:true
            },
            {
                id: 'manageCategories',
                title: Translate.manageCategories,
                type: 'item',
                icon: 'category',
                url: '/manage/manage-categories',
                exact:true
            },
            {
                id: 'manageTags',
                title: Translate.manageTags,
                type: 'item',
                icon: 'tag',
                url: '/manage/manage-tags',
                exact:true
            },
            {
                id: '/manage/manage-comments',
                title: Translate.manageComments,
                type: 'item',
                icon: 'comment',
                url: '/manage/manage-comments',
                exact:true
            },
        ],
    },
    {
        id: 'managePages',
        title: Translate.managePages,
        type: 'collapse',
        icon: 'description',
        roles: ['admin'],
        for: ['admin'],
        permission: 'manageSettings',
        children: [
            {
                id: 'manageHome',
                title: Translate.manageHome,
                type: 'item',
                icon: 'home',
                url: '/manage/pages/home',
                exact:true
            },
            {
                id: 'manageAbout',
                title: Translate.manageAbout,
                type: 'item',
                icon: 'info',
                url: '/manage/pages/about',
                exact:true
            },
            {
                id: 'manageTerms',
                title: Translate.manageTerms,
                type: 'item',
                icon: 'rule',
                url: '/manage/pages/terms',
                exact:true
            },
            {
                id: 'manageOrderDescription',
                title: Translate.manageOrderDescription,
                type: 'item',
                icon: 'shopping_cart',
                url: '/manage/pages/order_description',
                exact:true
            },
            {
                id: 'manageContact',
                title: Translate.manageContact,
                type: 'item',
                icon: 'contact_page',
                url: '/manage/pages/contact',
                exact:true
            },
        ],
    },
    {
        id: 'settings',
        title: Translate.settings,
        type: 'collapse',
        icon:'engineering',
        for:['admin'],
        roles: ['admin','support'],
        permission: 'manageSettings',
        children: [
            {
                id: 'manageCurrencies',
                title: Translate.manageCurrencies,
                type: 'item',
                icon: 'attach_money',
                url: '/manage/currencies',
                exact:true
            },
            {
                id: 'translateFront',
                title: Translate.translateFront,
                type: 'item',
                icon: 'translate',
                url: '/settings/translate-front',
                exact:true
            },
        ],
    },
    {
        id: 'account',
        title: Translate.account,
        icon: 'settings',
        type: 'collapse',
        children: [
            {
                id: 'password',
                title: Translate.changePassword,
                icon: 'password',
                type: 'item',
                url: '/account/password',
            }
        ],
    },

    {
        id: 'fileManager',
        title: Translate.fileManager,
        type: 'item',
        roles: ['admin','support'],
        for: ['admin'],
        icon: 'image',
        url: '/file-manager',
    },
    {
        id: 'logout',
        title: Translate.logOut,
        type: 'item',
        icon: 'power_settings_new',
        url: '/logout',
    },
];
export default routesConfig;
